import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f1a696fc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "info-box" }
const _hoisted_2 = { class: "contents" }
const _hoisted_3 = { class: "heaer-address" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "/" }, "首页", -1))
const _hoisted_5 = { class: "nav" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["onClick"]
const _hoisted_10 = /*#__PURE__*/_createStaticVNode("<div class=\"info\" data-v-f1a696fc><p class=\"info-title\" data-v-f1a696fc>实名认证</p><p class=\"info-tips\" data-v-f1a696fc>请选择以个人或企业身份进行认证</p><div class=\"info-list\" data-v-f1a696fc><div class=\"renzheng left\" data-v-f1a696fc><div class=\"header-img\" data-v-f1a696fc></div><p class=\"header-title\" data-v-f1a696fc>个人认证</p><p class=\"header-tips\" data-v-f1a696fc>用于个人认证，填写个人信息</p><a class=\"header-go-a\" href=\"/user/selfverify\" data-v-f1a696fc><div class=\"header-go\" data-v-f1a696fc>去认证</div></a><p class=\"header-help-p\" data-v-f1a696fc><a href=\"/customer/GerenRenzheng\" class=\"header-help\" data-v-f1a696fc>个人认证相关问题解答</a></p></div><div class=\"renzheng right\" data-v-f1a696fc><div class=\"header-img\" data-v-f1a696fc></div><p class=\"header-title\" data-v-f1a696fc>企业认证</p><p class=\"header-tips\" data-v-f1a696fc>用于企业认证，填写企业信息</p><a class=\"header-go-a\" href=\"/user/firmverify\" data-v-f1a696fc><div class=\"header-go\" data-v-f1a696fc>去认证</div></a><p class=\"header-help-p\" data-v-f1a696fc><a href=\"/customer/QiyeRenzheng\" class=\"header-help\" data-v-f1a696fc>企业认证相关问题解答</a></p></div></div></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_home_head = _resolveComponent("home-head")!
  const _component_CurrentAddress = _resolveComponent("CurrentAddress")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_html_footer = _resolveComponent("html-footer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_home_head),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_CurrentAddress, null, {
          address: _withCtx(() => [
            _hoisted_4,
            _createTextVNode(" > 用户指南")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("ul", _hoisted_5, [
        _createVNode(_component_router_link, {
          to: { name: 'aboutsite' },
          custom: ""
        }, {
          default: _withCtx(({ navigate }) => [
            _createElementVNode("li", {
              onClick: navigate,
              role: "link"
            }, "使用规则", 8, _hoisted_6)
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          to: { name: 'renzheng' },
          custom: ""
        }, {
          default: _withCtx(({ navigate }) => [
            _createElementVNode("li", {
              onClick: navigate,
              role: "link"
            }, "实名认证", 8, _hoisted_7)
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          to: { name: 'cooperation' },
          custom: ""
        }, {
          default: _withCtx(({ navigate }) => [
            _createElementVNode("li", {
              onClick: navigate,
              role: "link"
            }, "合作协议", 8, _hoisted_8)
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          to: { name: 'privacyPolicy' },
          custom: ""
        }, {
          default: _withCtx(({ navigate }) => [
            _createElementVNode("li", {
              onClick: navigate,
              role: "link"
            }, "隐私政策", 8, _hoisted_9)
          ]),
          _: 1
        })
      ]),
      _hoisted_10
    ]),
    _createVNode(_component_html_footer)
  ]))
}